import {PropertyButtonEventType} from "../gtm_event_property_button";

interface Params {
    isPromotion?: boolean;
    isReservation?: boolean;
    isPlansList?: boolean;
    isInModal?: boolean;
    baseLabel?: string;
}

export const getPropertyButtonEventMeta = (params: Params) => {
    const {isPromotion, isReservation, isPlansList, isInModal, baseLabel} = params;
    const eventMeta = {event: PropertyButtonEventType.TILE, label: baseLabel || "zobacz więcej"};
    if (isPromotion) {
        eventMeta.label = "promocja";
    }
    if (isReservation) {
        eventMeta.label = "rezerwacja";
    }
    if (!isPlansList) {
        eventMeta.event = isInModal ? PropertyButtonEventType.MODAL_LIST : PropertyButtonEventType.LIST;
    }
    return eventMeta;
};
import {PropertyButtonEventType} from "../gtm_event_property_button";

interface Params {
    isPromotion?: boolean;
    isReservation?: boolean;
    isPlansList?: boolean;
    isInModal?: boolean;
    baseLabel?: string;
}

export const getPropertyButtonEventMeta = (params: Params) => {
    const {isPromotion, isReservation, isPlansList, isInModal, baseLabel} = params;
    const eventMeta = {event: PropertyButtonEventType.TILE, label: baseLabel || "zobacz więcej"};
    if (isPromotion) {
        eventMeta.label = "promocja";
    }
    if (isReservation) {
        eventMeta.label = "rezerwacja";
    }
    if (!isPlansList) {
        eventMeta.event = isInModal ? PropertyButtonEventType.MODAL_LIST : PropertyButtonEventType.LIST;
    }
    return eventMeta;
};
